module.exports = __webpack_public_path__ + "static/media/what_img3.8a0afffa.webp";